import { useCallback, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { OAuthLoginData, User } from '@front/common/src/types/commons';

import { accountCreated } from '../../utils/tracking';
import { getNextPath, getPreviousPath } from '../../utils/navigation';
import { SIGN_IN_PATH, route, SIGNUP_PATH } from '../../steps/steps';

const useSignupNavigation = (isSignedIn: boolean) => {
  const navigate = useNavigate();
  const location = useLocation();
  const to = getNextPath(location);
  const from = getPreviousPath(location);

  const onAccountCreated = () => {
    accountCreated();
    navigate(to || from, { state: { newAccount: true }, replace: true });
  };

  const openLoginScreen = useCallback(() => {
    navigate(route(SIGN_IN_PATH), { state: { from, to } });
  }, [from, navigate, to]);

  const gotoSignup = (omniAuthData?: OAuthLoginData, partialUser?: Partial<User>) => {
    navigate(route(SIGNUP_PATH), { state: { from, to, omniAuthData, partialUser } });
  };

  useEffect(() => {
    /**
     * In the tunnel workflow, the user could land on the signup screen and then decide to
     * login via the login button in the header. If he/she then clicks on the header's back
     * button after successful login, we need to make sure to not show the sign up screen again.
     */
    if (isSignedIn) {
      navigate(-1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    onAccountCreated,
    openLoginScreen,
    gotoSignup,
  };
};

export default useSignupNavigation;
